import { Icon16Stars } from '@vkontakte/icons';
import { ReactComponent as LogoMailIcon } from 'img/icons/logo_mail_ru_16.svg';
import React from 'react';
import { helpAutoUploadHref } from 'reactApp/appHelpers/featuresHelpers/features/autoUploadPromo';
import { SHOW_EDITING_DOCUMENT_SHORT_FEATURE_TEXT } from 'reactApp/appHelpers/featuresHelpers/features/showEditingDocumentFeature';
import { templateFeatureIcons } from 'reactApp/constants/products/templateFeatureIcons';

const APP_PASSWORDS_FEATURE_TEXT = 'Пароли для внешних сервисов';

export const templateFeatures = {
    // Про рекламу
    noadsWeb: {
        text: 'Без рекламы в веб-версии',
        key: 'ad',
    },
    noads: {
        text: 'Без рекламы',
        key: 'ad',
    },
    noadsMailCloud: {
        text: 'Без рекламы в Почте и Облаке',
        key: 'ad',
    },
    noadsMailCloudNew: {
        text: 'Почта и Облако без рекламы',
        key: 'ad',
    },

    // Про квоту на загрузку
    upload100: {
        text: 'Загрузка файлов до\u00A0100\u00A0ГБ',
        key: 'upload',
    },
    upload100Cloud: {
        text: 'Загрузка файлов до\u00A0100\u00A0ГБ в\u00A0Облако',
        key: 'upload',
    },
    upload2Cloud: {
        text: 'Загрузка файлов до\u00A02\u00A0ГБ в\u00A0Облако',
        key: 'upload',
    },

    // Про папки
    foldersAutodelete: {
        text: 'Автоудаление папок',
        key: 'autodelete',
    },
    foldersAutodeleteTimer: {
        text: 'Таймер для автоудаления отправленных папок',
        key: 'autodelete',
    },
    history60: {
        text: '60 дней истории изменений файлов',
        key: 'hist',
    },

    // Про ДискО
    diskoAllColored: {
        text: 'Доступ ко\u00A0всем возможностям Диск&#8209;О:',
        key: 'disko',
    },
    diskoAll: {
        text: 'Доступ ко\u00A0всем возможностям Диск-О:',
        key: 'disko',
    },

    // Про дубликаты
    duplicates: {
        text: 'Удаление дубликатов',
        key: 'duplicates',
    },

    // Про бонусы
    bonuses: {
        text: 'Скидки и бонусы от партнеров',
        key: 'discount',
    },
    otherBenefits: {
        text: 'И другие возможности',
        textJsx: (
            <>
                И другие{'\u00A0'}
                <a href="#benefits">возможности</a>
            </>
        ),
        key: 'benefits',
    },

    // Про поддержку
    supportFast: {
        text: 'Быстрая поддержка — ответим в течение часа с\u00A09:00\u00A0до\u00A021:00\u00A0МСК',
        key: 'support',
    },
    supportFastAnswer: {
        text: 'Быстрый ответ поддержки',
        key: 'support',
    },
    supportFastAnswerHour: {
        text: 'Быстрый ответ от поддержки — в течение часа',
        key: 'support',
    },
    supportPriority: {
        text: 'Приоритетная поддержка',
        key: 'support',
    },

    // Про семью
    familyShare: {
        text: 'Делитесь местом с\u00A0близкими',
        key: 'family',
    },
    familyAdd3: {
        text: 'Добавление ещё 3\u00A0участников',
        key: 'family',
    },

    // Прочее про Почту
    letterCancel: {
        text: 'Отмена отправки писем',
        key: 'cancel',
    },
    send100Mail: {
        text: 'Отправка файлов до\u00A0100\u00A0ГБ в\u00A0письмах',
        key: 'sending',
    },
    sendAttaches100Mail: {
        text: 'Отправка вложений до\u00A0100\u00A0ГБ в\u00A0Почте',
        key: 'sending',
    },
    send100: {
        text: 'Отправка файлов до\u00A0100\u00A0ГБ',
        key: 'sending',
    },
    readNotify: {
        text: 'Уведомление о\u00A0прочтении',
        key: 'readNotify',
    },

    // Про редактирование
    editingDocuments: {
        text: SHOW_EDITING_DOCUMENT_SHORT_FEATURE_TEXT,
        key: 'editingDocuments',
    },

    // Про автозагрузку
    autoUpload: {
        text: 'Безлимитная автозагрузка  - как это работает',
        textJsx: (
            <>
                Безлимитная автозагрузка
                <br />с телефона &ndash;{' '}
                <a href={helpAutoUploadHref} target="_blank" rel="noopener noreferrer">
                    как это работает
                </a>
            </>
        ),
        key: 'autoupload',
    },
    autoUpload2: {
        text: 'Безлимит для фото с телефона',
        key: 'autoupload2',
    },

    // Про VK Музыку
    vkMusic: { text: 'VK Музыка без ограничений', key: 'vkmusic' },

    prettyAddress: {
        key: 'pretty_address',
        text: 'Красивый адрес для почты',
        usePropsIcon: true,
        accent: true,
        icon: <LogoMailIcon height={16} />,
    },

    // Про AI Фичи
    letterGen: {
        text: 'Генерация и изменение писем',
        key: 'generate_ai',
        icon: <Icon16Stars />,
        usePropsIcon: true,
        accent: true,
    },

    letterGenSecondary: {
        text: 'Генерация и изменение писем',
        key: 'generate_ai',
    },

    neurofilter: {
        text: 'Нейропомощник в\u00A0Почте',
        key: 'neurofilter',
    },

    aiPhotoImproving: {
        text: 'Улучшение фото в\u00A0веб-версии',
        key: 'aiPhotoImproving',
    },

    aiPhotoGeneration: {
        text: 'Создание изображений в\u00A0мобильной версии',
        key: 'aiPhotoGeneration',
    },

    // Про оверквоту
    restrictionsGone: {
        text: 'Пропадут все ограничения',
        key: 'restrictionsGone',
    },
    testMailSpace: {
        text: 'Проверите Mail Space в деле',
        key: 'testMailSpace',
    },
    appPasswords: {
        text: APP_PASSWORDS_FEATURE_TEXT,
        key: 'app_pass',
        usePropsIcon: true,
        styleColor: 'var(--vkui--color_accent_cyan)',
        icon: templateFeatureIcons.vkui16KeyOutline,
    },
    appPasswordsAccent: {
        text: APP_PASSWORDS_FEATURE_TEXT,
        key: 'app_pass',
        usePropsIcon: true,
        accent: true,
        icon: templateFeatureIcons.vkui16KeyOutline,
    },
    appPasswordsSecondary: {
        text: APP_PASSWORDS_FEATURE_TEXT,
        key: 'app_pass',
    },
};
